





























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'

@Component
export default class UserLayout extends Vue {

  private menuItems = [
    {
      title: 'تنظیمات عمومی',
      to: ''//this.userRoutes.profileIndex
    },
    {
      title: 'تنظیمات اعلانات',
      to: ''//this.userRoutes.manageNotifications
    }
  ]
}
